export default function() {
    const stytch = window.stytchClient;
    const session = stytch.session.getSync();
    return session?.member_id;
}